import axios from 'axios'
import md5 from 'blueimp-md5'
import * as systemConfig from './config'
import store from './vuex/store'
import * as types from './vuex/types'
import router from './router'
import { Message } from 'element-ui'

// 这个函数是将要传的参数对象转化成字符串，同时加上阿杰的神奇校验机制
// 请求安全校验机制如下：
// ---------------------------------------
// 先对请求参数各个字段的值进行字符串拼接，然后再加上 check_key 的值拼 接。
// 对拼接好的字符串进行 md5 取值，将得到的值放入请求参数中，key 为 url_check
// 例子:
// post 的参数有 :
// param1 = 10,
// param2 =15,
// check_key = 29419eae77550b039c0e56c007e27076
// 拼接后的字符串为: 101529419eae77550b039c0e56c007e27076,
// md5 值: md5(101529419eae77550b039c0e56c007e27076)
// =763c991e6721abe95aebbb95fd45e808
// -----------------------------------------
// 把 url_check=763c991e6721abe95aebbb95fd45e808 加入请求参数中。
// 最终的 post 参数为:
// param1 = 10,
// param2 =15,
// url_check=763c991e6721abe95aebbb95fd45e808-
// -----------------------------------------
function transformRequest (paramsObj = {}) {
  // 按键值排序
  let data = {}
  Object.keys(paramsObj).sort().forEach((key) => {
    data[key] = paramsObj[key]
  })
  let urlCheck = ''
  let ret = ''
  for (let it in data) {
    if (data[it] === null || typeof data[it] === 'undefined') {
      continue
    }
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    urlCheck += data[it]
  }
  urlCheck += systemConfig.CHECK_KEY
  urlCheck = md5(urlCheck)
  ret += 'sign=' + urlCheck
  return ret
}

// axios全局超时设置
axios.defaults.timeout = 60 * 1000 * 5

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // header加sid
    var sessionId = store.state.sessionId
    if (sessionId) {
      config.headers['sid'] = sessionId
    }
    // header设置表单提交
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8;'
    config.headers['role'] = 3
    config.transformRequest = transformRequest
    return config
  },
  err => {
    Message.error({
      message: '请求超时，请检查您的网络环境是否正常',
      showClose: true
    })
    console.log(err)
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    let data = response.data
    if (data && data.code) {
      let code = data.code
      // 如果返回数据结构中code为10004、10005、10006，就跳转微信授权URL
      if (code === 10004 || code === 10005 || code === 10006) {
        store.commit(types.LOGOUT)
        router.replace({ name: 'login' })
        return Promise.reject(response)
      }
    }
    return response
  },
  error => {
    // 返回业务catch块处理
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/http.js